module.exports = __webpack_public_path__ + "media/src/images/logos/zoom-5ea010edbaa63179fb930b698c24f21e.png";